// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28dQ0","textarea":"styles_textarea__1iB6A"};